import moment from 'moment'

export enum ClockSystem {
  '12H' = '12H',
  '24H' = '24H'
}

export enum TimeUnits {
  'AM' = 'AM',
  'PM' = 'PM'
}

export interface WheelPickerColumn {
  values: string[]
  separator?: string
}

export interface TimePickerProps {
  initialTime: moment.Moment
  minTime?: string // 'HH:mm' format
  maxTime?: string // 'HH:mm' format
  onSelectedTimeChange: (selectedTime: moment.Moment) => void
  testID?: string
}

export interface WheelPickerProps {
  selectedIndexes: number[]
  columns: WheelPickerColumn[]
  onSelectedIndex: (columnIndex: number, index: number) => void
  visibleRows?: number
  testID?: string
}

export interface WheelColumnProps {
  values: string[]
  selectedIndex: number
  onSelectedIndex: (index: number) => void
  visibleRows?: number
  separator?: string
  testID?: string
}

export interface SelectedIndexesState {
  hour: number | undefined
  minutes: number | undefined
  unit: number | undefined
}
